// @moods/ui copy for the identity components. tr and en must have identical keys.
// Turkish part; identity.en.ts must have the same keys.
const dict: Record<string, string> = {
  'identity.status.online': 'Çevrimiçi',
  'identity.status.idle': 'Boşta',
  'identity.status.dnd': 'Rahatsız Etmeyin',
  'identity.status.offline': 'Çevrimdışı',
  'identity.status.invisible': 'Görünmez',
  'identity.status.streaming': 'Yayında',
  'identity.status.mobile': 'Mobilde çevrimiçi',

  'identity.activity.kind.playing': 'Oynuyor',
  'identity.activity.kind.listening': 'Dinliyor',
  'identity.activity.kind.watching': 'İzliyor',
  'identity.activity.kind.streaming': 'Yayında',
  'identity.activity.kind.coding': 'Kodluyor',
  'identity.activity.kind.other': 'Durum',
  'identity.activity.text.playing': '{name} oynuyor',
  'identity.activity.text.listening': '{name} dinliyor',
  'identity.activity.text.watching': '{name} izliyor',
  'identity.activity.text.streaming': '{name} yayında',
  'identity.activity.text.coding': '{name} kodluyor',
  'identity.activity.progress': 'İlerleme',

  'identity.elapsed.now': 'az önce',
  'identity.elapsed.m': '{m} dk',
  'identity.elapsed.h': '{h} sa',
  'identity.elapsed.hm': '{h} sa {m} dk',

  'identity.stack.more': '{count} kişi daha',

  'identity.member.owner': 'Topluluk sahibi',
  'identity.member.bot': 'BOT',
  'identity.member.message': '{name} adlı kişiye mesaj gönder',
  'identity.member.group': '{label} — {count}',
  'identity.memberList.label': 'Üye listesi',

  'identity.badges.label': 'Rozetler',
  'identity.badge.verified': 'Doğrulanmış',
  'identity.badge.developer': 'Geliştirici',
  'identity.badge.early': 'Erken üye',
  'identity.badge.creator': 'İçerik üreticisi',
  'identity.badge.moderator': 'Moderatör',
  'identity.badge.bot': 'Bot',
  'identity.badge.premium': 'Premium',

  'identity.conn.label': 'Bağlantılar',
  'identity.conn.website': 'Web sitesi',
  'identity.conn.item': '{service}: {handle}',

  'identity.profile.label': '{name} profili',
  'identity.profile.roles': 'Roller',
  'identity.profile.editRoles': 'Rolleri düzenle',
  'identity.profile.note': 'Not',
  'identity.profile.notePlaceholder': 'Not eklemek için tıkla',
  'identity.profile.message': '@{handle} adlı kişiye mesaj gönder',
  'identity.profile.mutualCommunities.one': '{count} ortak topluluk',
  'identity.profile.mutualCommunities.other': '{count} ortak topluluk',
  'identity.profile.mutualFriends.one': '{count} ortak arkadaş',
  'identity.profile.mutualFriends.other': '{count} ortak arkadaş',
};

export default dict;
